module.exports = __webpack_public_path__ + "img/edmbet-support.3df24dd3.jpg";